import { Component, computed, EventEmitter, input, InputSignal, model, ModelSignal, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';

@Component({
  selector: 'session-timeout',
  imports: [DialogModule, ButtonModule, TranslateModule],
  templateUrl: './session-timeout.component.html',
  styleUrl: './session-timeout.component.css'
})
export class SessionTimeoutComponent {
  
  showModal: ModelSignal<boolean> = model.required();
  timeLeft: InputSignal<number> = input.required();
  @Output() continueSession = new EventEmitter<void>();
  @Output() logout = new EventEmitter<void>();

  countdown = computed( ()=> Math.ceil(this.timeLeft() / 1000));

  continueNow(){
    this.continueSession.emit();
    this.closeModal();
  }

  logoutNow(){
    this.logout.emit();
    this.closeModal();
  }
  
  closeModal() {
    this.showModal.set(false);
  }

}